import React from 'react'
import { observer } from 'mobx-react'
import './index.scss'
import { SearchResultPartyDetails } from '@Entities/party-details'
import SongwriterMyWritersRow from '@Scenes/SongwriterScene/SongwriterMyWritersScene/SongwriterMyWritersTable/SongwriterMyWritersRow'

interface SongwriterLinkTableProps {
    data: SearchResultPartyDetails[]
    linkedWriterIpIds: Set<number>
    onTitleClick: (partyDetails: SearchResultPartyDetails) => void
    onWriterToggle: (isLinked: boolean, writerIpId: number) => void
    requestAnUpdate(selectedWriter: SearchResultPartyDetails): void
}
const SongwriterMyWritersTable = ({
    data,
    onTitleClick,
    linkedWriterIpIds,
    onWriterToggle,
    requestAnUpdate,
}: SongwriterLinkTableProps) => (
    <div className="songwriter-my-writer-table">
        <div className="songwriter-my-writer-table-headers">
            <div>In Catalog?</div>
            <div>My Writer Name</div>
            <div>Number of Songs</div>
        </div>
        <div className="songwriter-my-writer-table-body">
            {data.map((writer) => (
                <SongwriterMyWritersRow
                    key={writer.ipId}
                    writer={writer}
                    onWriterToggle={onWriterToggle}
                    onTitleClick={onTitleClick}
                    isChecked={linkedWriterIpIds.has(Number(writer.ipId))}
                    requestAnUpdate={requestAnUpdate}
                />
            ))}
        </div>
    </div>
)

export default observer(SongwriterMyWritersTable)
